/**
 * Comments API Service
 * API calls for comments
 */

import type {
	CommentRecord,
	CreateCommentInput,
	GetCommentsOptions,
	GetCommentsResponse,
} from "@shared/types";
import { apiClient } from "@/lib/api-client";

const API_BASE = "/api/v1";

export async function getProjectComments(
	projectId: string,
	options: GetCommentsOptions = {},
): Promise<GetCommentsResponse> {
	const response = await apiClient.get(
		`${API_BASE}/comments/project/${projectId}`,
		{
			params: options,
		},
	);

	return {
		comments: response.data.data.comments,
		total: response.data.data.pagination.total,
		page: response.data.data.pagination.page,
		limit: response.data.data.pagination.limit,
		hasMore:
			response.data.data.pagination.page <
			response.data.data.pagination.totalPages,
	};
}

export async function createComment(
	input: CreateCommentInput,
): Promise<{ comment: CommentRecord }> {
	const response = await apiClient.post(
		`${API_BASE}/comments/project/${input.projectId}`,
		{ content: input.content },
	);
	return response.data.data;
}
